<template>
  <optgroup>
    <BFormSelectOption
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :disabled="option.disabled"
    />
  </optgroup>
</template>

<script>
import BFormSelectOption from './BFormSelectOption.vue'
export default {
  name: 'BFormSelectOptionGroup',
  components: {
    BFormSelectOption
  },
  props: {
    label: {
      type: String,
      default: undefined,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  }
}
</script>
